import { useTheme } from 'styled-components';

import Accordion from '@components/Accordion/next/Accordion';
import { useDevice } from '@contexts/device';
import Typography from '@components/Typography';

import { MultiSelectionFilterWrapper } from './MultiSelectionFilterStyle';
import MultiSelectionFilter from './MultiSelectionFilter';
import { MultiSelectionFilterProps } from './types';

const CollapsibleMultiSelectionFilter = (props: MultiSelectionFilterProps) => {
  const { title, selectedItems, showSelectedItemsCount, ...rest } = props;
  const { palette } = useTheme();
  const { ...multiSelectionFilterProps } = rest;
  const { isDesktop } = useDevice();

  return (
    <MultiSelectionFilterWrapper>
      <Accordion
        label={
          <>
            <Typography variant='caption1' color='NL800' weight='Bold'>
              {title}
              {showSelectedItemsCount ? (
                <span>({selectedItems.length} Seçildi)</span>
              ) : null}
            </Typography>
          </>
        }
        headerContentColor='eclipse'
        alwaysShowBottomBorder={false}
        headerPadding={isDesktop ? '0px' : '15px'}
        mobileLabelFontSize='16px'
        iconSize={16}
        iconColor='NL800'
        contentPadding='0px 0px 8px 0px'
        backgroundColor='white'
        bodyBackgroundColor={isDesktop ? 'transparent2' : 'white'}
        defaultOpen={props.openTranferFilter ? true : false}
        accordionContentBorderRadius='0px'
        accordionWrapperStyles={{
          borderRadius: '8px',
          overflow: 'hidden',
        }}
        labelFontSize='16px'
        accordionTitleStyles={{
          color: palette.NL800,
        }}
      >
        <MultiSelectionFilter
          selectedItems={selectedItems}
          {...multiSelectionFilterProps}
        />
      </Accordion>
    </MultiSelectionFilterWrapper>
  );
};

export default CollapsibleMultiSelectionFilter;
